import { AfterViewInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HelpService } from '@core/services/help.service';
import { DeviceService } from '@app/shared/helpers/device.service';
import { DeviceType } from '@app/shared/enum/device-type';

@Component({
    selector: 'app-main-layout',
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss'],
    standalone: false,
})
export class MainLayoutComponent implements AfterViewInit {
    isMobile = false;
    isAuthenticated = false;
    showHelpPanel$: Observable<boolean>;

    constructor(
        private router: Router,
        private helpService: HelpService,
        private deviceService: DeviceService
    ) {
        this.showHelpPanel$ = this.helpService.showPanel$;
    }

    ngAfterViewInit() {
        this.deviceService.deviceType$.subscribe((deviceType) => {
            setTimeout(() => {
                this.isMobile = deviceType === DeviceType.mobile;
            });
        });
    }
}
